
    /**
    * 前台用户验证码登陆
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13240 {
  /**
   * 手机号
   */
  mobile: string | number;
  /**
   * 验证码
   */
  captcha: string | number;
}
  export class IResid13240 {
  code?: number;
  data?: {
    anchorImage?: string;
    anchorName?: string;
    token?: string;
  };
  message?: string;
  success?: boolean;
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid13240, IResid13240['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/account/loginByCaptcha',
        params: data
      }) 
  export default http